import React from 'react';

export const Footer = () => {
    return (
        <footer className="footer">
            <a href="http://radzimin.ski" className="footer__link" target="_blank" rel="noopener noreferrer">
                &copy; Jan Radzimiński 2020
            </a>
        </footer>
    );
};
